// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"f192ab00","455":"ddb4af5f","977":"0b9402d9"}[chunkId] + ".chunk.js";
};